import styled from 'styled-components';

export const Card = styled.div`
  border-right: 2px solid #e7e9ea;
  border-bottom: 2px solid #e7e9ea;
  background-color: white;
`;
